import React from 'react';
import { View, Text, StyleSheet } from 'react-native';

interface SplitStatusBadgeProps {
  status: 'PENDING' | 'PAID' | 'WITHHELD' | 'ACTIVE' | 'INACTIVE';
  size?: 'small' | 'medium';
}

/**
 * Universal status badge for split payouts and split status
 */
const SplitStatusBadge: React.FC<SplitStatusBadgeProps> = ({
  status,
  size = 'medium',
}) => {
  const getStatusConfig = () => {
    switch (status) {
      case 'PAID':
        return {
          label: 'Paid',
          color: '#10B981', // Green
          dot: '●',
        };
      case 'PENDING':
        return {
          label: 'Pending',
          color: '#F59E0B', // Yellow/Orange
          dot: '●',
        };
      case 'WITHHELD':
        return {
          label: 'Held',
          color: '#EF4444', // Red
          dot: '●',
        };
      case 'ACTIVE':
        return {
          label: 'Active',
          color: '#10B981', // Green
          dot: '●',
        };
      case 'INACTIVE':
        return {
          label: 'Inactive',
          color: '#6B7280', // Gray
          dot: '●',
        };
      default:
        return {
          label: status,
          color: '#6B7280',
          dot: '●',
        };
    }
  };

  const config = getStatusConfig();
  const isSmall = size === 'small';

  return (
    <View style={[styles.badge, isSmall && styles.badgeSmall]}>
      <Text style={[styles.dot, { color: config.color }, isSmall && styles.dotSmall]}>
        {config.dot}
      </Text>
      <Text style={[styles.label, { color: config.color }, isSmall && styles.labelSmall]}>
        {config.label}
      </Text>
    </View>
  );
};

const styles = StyleSheet.create({
  badge: {
    flexDirection: 'row',
    alignItems: 'center',
    backgroundColor: '#1A1D23',
    paddingHorizontal: 8,
    paddingVertical: 4,
    borderRadius: 12,
    gap: 4,
  },
  badgeSmall: {
    paddingHorizontal: 6,
    paddingVertical: 2,
    borderRadius: 8,
    gap: 2,
  },
  dot: {
    fontSize: 12,
    lineHeight: 12,
  },
  dotSmall: {
    fontSize: 10,
    lineHeight: 10,
  },
  label: {
    fontSize: 12,
    fontWeight: '600',
  },
  labelSmall: {
    fontSize: 10,
  },
});

export default SplitStatusBadge;

